import { Tooltip as TooltipAD, TooltipProps as TooltipADProps } from "antd";
import clsx from "clsx";
import * as React from "react";
import { createGlobalStyle } from "styled-components";

export const TooltipGlobalStyle = createGlobalStyle`
  /* antd's default dark tooltip is rgba(0, 0, 0, 0.75), which lets busy content underneath
     (form labels, table rules) bleed through a longer tooltip. A shade darker, applied to
     every tooltip so they all match; .tooltip-light below still wins for that variant. */
  .ant-tooltip-inner {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .ant-tooltip-arrow-content {
    --antd-arrow-background-color: linear-gradient(
      to right bottom,
      rgba(0, 0, 0, 0.7),
      rgba(0, 0, 0, 0.8)
    );
  }

  .tooltip-light {
    .ant-tooltip-arrow .ant-tooltip-arrow-content::before {
      background: #fff;
    }

    .ant-tooltip-content {
      background: white;
      border-radius: 5px;

      .ant-tooltip-arrow {
        .ant-tooltip-arrow-content {
          background: white;
        }
      }

      .ant-tooltip-inner {
        background: white;
        border-radius: 5px;
        min-height: 28px;
        padding: 3px 6px;
        color: #262626;
      }
    }

    .ant-tooltip-arrow-content::before {
      background: white;
    }
  }
`;

type Props = TooltipADProps & {
  variant?: "light";
};

export const Tooltip: React.FC<Props> = ({ children, mouseLeaveDelay, ...props }) => (
  <TooltipAD
    mouseLeaveDelay={mouseLeaveDelay ?? 0}
    overlayClassName={clsx({ "tooltip-light": props.variant === "light" })}
    {...props}
  >
    {children}
  </TooltipAD>
);
